import { AspectRatio, Box } from "@mantine/core";

import classes from "./CarburateLoader.module.css";

import type { FC } from "react";

export type CarburateLoaderProps = {
  size?: number;
};

export const CarburateLoader: FC<CarburateLoaderProps> = ({ size = 200 }) => {
  return (
    <AspectRatio ratio={68 / 8} w={size}>
      <Box className={classes.root} style={{ backgroundSize: size }} w="100%" h="100%" />
    </AspectRatio>
  );
};
